import { render, staticRenderFns } from "./legalAdviceQuestions.vue?vue&type=template&id=5cb36cf4&scoped=true&"
import script from "./legalAdviceQuestions.vue?vue&type=script&lang=js&"
export * from "./legalAdviceQuestions.vue?vue&type=script&lang=js&"
import style0 from "./legalAdviceQuestions.vue?vue&type=style&index=0&id=5cb36cf4&prod&lang=less&scoped=true&"
import style1 from "./legalAdviceQuestions.vue?vue&type=style&index=1&id=5cb36cf4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb36cf4",
  null
  
)

export default component.exports